import React, {
  FunctionComponent,
  ReactNode,
  PureComponent,
  MouseEventHandler,
} from 'react';
import cn from 'classnames';
import './Card.pcss';

interface ContentProps {
  children?: ReactNode;
}
interface CardProps extends ContentProps {
  disable?: boolean;
  className?: string;
  error: boolean;
}

interface ButtonProps extends ContentProps {
  onClick?: MouseEventHandler;
  className: string;
}

export type ButtonComponent = FunctionComponent<ButtonProps>;

export const CardTop = ({ children }: ContentProps): JSX.Element => (
  <div className="Card__topContent">{children}</div>
);

export const CardBottom = ({ children }: ContentProps): JSX.Element => (
  <div className="Card__bottomContent">{children}</div>
);

const CardButton: ButtonComponent = ({
  onClick,
  className = '',
  children,
}): JSX.Element => {
  return (
    <button
      type="button"
      className={cn('mos-link', 'Card__button', className)}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

class Card extends PureComponent<CardProps> {
  public static Top = CardTop;
  public static Button = CardButton;
  public static Bottom = CardBottom;

  public static defaultProps = {
    disable: false,
    error: false,
  };

  public render(): JSX.Element {
    const { className, disable, children, error } = this.props;
    const classNames = cn(
      {
        Card: true,
        Card_disabled: disable,
        Card_error: error,
      },
      className
    );
    return <div className={classNames}>{children}</div>;
  }
}

export default Card;
